import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    FirstName: {
      validations: [
        { type: 'required', message: 'First name is required.' }
      ]
    },
    LastName: {
      validations: [
        { type: 'required', message: 'Last name is required.' }
      ]
    },
    TelNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' },
        { type: 'required', message: 'Phone is required.' }
      ]
    },
    Email: {
      validations: [
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' },
        { type: 'required', message: 'Email is required.' }
      ]
    },
    AddressLine1: {
      validations: []
    },
    AccountExtra8: {
      validations: []
    },
    City: {
      validations: []
    },
    State: {
      validations: []
    },
    Postal: {
      validations: [
        { type: 'maxLength', maxLength: 5, message: 'Enter 5 digit zip code' }
      ]
    },
    AccountExtra9: {
      validations: []
    },
    PartyName: {
      validations: [
        { type: 'required', message: 'Name of Event is required.' }
      ]
    },
    Theme: {
      validations: []
    },
    AccountExtra2: {
      validations: []
    },
    AccountExtra3: {
      validations: []
    },
    AccountExtra4: {
      validations: []
    },
    AccountExtra5: {
      validations: []
    },
    PlannedGuestCount: {
      validations: []
    },
    AccountExtra6: {
      validations: []
    },
    AccountExtra7: {
      validations: []
    },
    Notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name*',
            mapping: 'FirstName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name*',
            mapping: 'LastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number*',
            mapping: 'TelNumber'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Email*',
            mapping: 'Email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Address Line 1',
            mapping: 'AddressLine1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Address Line 2',
            mapping: 'AccountExtra8'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'City',
            mapping: 'City'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'State/Province/Region',
            mapping: 'State'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Zip:',
            mapping: 'Postal'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Country',
            mapping: 'AccountExtra9'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Name of Event*',
            mapping: 'PartyName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Type of Event',
            options: [
              { label: 'Meeting and Rooms' , value: 'Meeting and Rooms'},
              { label: 'Wedding and Rooms', value: 'Wedding and Rooms'},
              { label: 'Social Function and Rooms', value: 'Social Function and Rooms'},
              { label: 'Meeting no Rooms', value: 'Meeting no Rooms' },
              { label: 'Wedding no Rooms', value: 'Wedding no Rooms' },
              { label: 'Social function no Rooms', value: 'Social function no Rooms' },
            ],
            mapping: 'Theme'
          },
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Have you held an event at the Atlantic Hotel previously?',
            options: [
              { label: 'Yes', value: 'Yes' },
              { label: 'No', value: 'No' }
            ],
            mapping: 'AccountExtra2'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Start Date*',
            mapping: 'AccountExtra3'
          },
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'End Date',
            mapping: 'AccountExtra4'
          },
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Is This Date Flexible?',
            options: [
              { label: 'Yes', value: 'Yes' },
              { label: 'No', value: 'No' }
            ],
            mapping: 'AccountExtra5'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Total Number of Guests',
            mapping: 'PlannedGuestCount'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Total Number of Rooms',
            mapping: 'AccountExtra6'
          },
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'How Should We Respond?',
            options: [
              { label: 'Phone', value: 'Phone' },
              { label: 'E-mail', value: 'E-mail' },
              { label: 'Mail', value: 'Mail' }
            ],
            mapping: 'AccountExtra7'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Function Requirements',
            mapping: 'Notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'The Atlantic Hotel & Spa Contact Form',
    formId: '440',
    clientKey: 'DCDAEE51-6F31-4F99-A72E-83C324D0AC9B',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/web_inquiry/inquiry-renderer/client_forms/theatlantichotelandspa/form_structure.js